import { gql } from '@apollo/client';

const GET_CONTENT = gql`
  query book($where: BookWhereInput!) {
    bookContent(where: $where) {
      id
      pageNumber
      value
    }
  }
`;

export default GET_CONTENT;
